<template>
  <div class="">
    <p>وضعیت انبار</p>
    <select @change="quantityFilter" v-model="quantity" class="custom-select">
      <option value="">نمایش همه</option>
      <option value="1">موجود</option>
      <option value="0">ناموجود</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "Quantity",
  data() {
    return {
      quantity: '',
    }
  },
  methods: {
    quantityFilter() {
      this.$store.commit("Product/setFilters", {key: "quantity", value: this.quantity});
      this.$emit('updateFilter', {quantity: this.quantity})
      this.$store.dispatch('Product/setDashboardProducts', 1)
    }
  },
  mounted() {
    const value = this.$route.query.quantity;
    if (value != undefined) {
      this.$store.commit('Product/setFilters', {key: 'quantity', value: value})
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "quantity", value: ''});
  }
}
</script>

<style scoped>

</style>